import simpleMenu from './SimpleMenu';

export default function header() {
  let lastScrollTop = 0;
  const mainWrapper = document.getElementById('wrapper') as HTMLElement;
  const autohideElement = document.getElementById('header') as HTMLElement;

  function positionHeader() {
    const scrollTop = window.scrollY;
    if (scrollTop === 0) {
      autohideElement.classList.add('scrolled-top');
      autohideElement.classList.remove('scrolled-down', 'scrolled-up');

      mainWrapper.classList.add('scrolled-top');
      mainWrapper.classList.remove('scrolled-down', 'scrolled-up');
    } else if (scrollTop < lastScrollTop) {
      autohideElement.classList.remove('scrolled-top', 'scrolled-down');
      autohideElement.classList.add('scrolled-up');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-down');
      mainWrapper.classList.add('scrolled-up');
    } else {
      autohideElement.classList.remove('scrolled-top', 'scrolled-up');
      autohideElement.classList.add('scrolled-down');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-up');
      mainWrapper.classList.add('scrolled-down');
    }
    lastScrollTop = scrollTop;
  }

  if (autohideElement && mainWrapper) {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('scroll', () => {
        positionHeader();
      });
      positionHeader();
    });
  }
  return {
    open: false,
    hover: false,
    openDialog() {
      this.open = true;
      document.body.style.overflowY = 'hidden';
    },
    closeDialog() {
      this.open = false;
      document.body.style.overflowY = 'initial';
    },
    addHover() {
      this.hover = true;
    },
    removeHover() {
      this.hover = false;
    },
    toggleOpen() {
      if (this.open) {
        this.closeDialog();
        this.removeHover();
      } else {
        this.openDialog();
        this.addHover();
      }
    },
    ...simpleMenu(),
  };
}
